export const europeanCountries = {
	AD: 'Andorra',
	AL: 'Albania',
	AT: 'Austria',
	AX: 'Åland Islands',
	BA: 'Bosnia and Herzegovina',
	BE: 'Belgium',
	BG: 'Bulgaria',
	BY: 'Belarus',
	CH: 'Switzerland',
	CY: 'Cyprus',
	CZ: 'Czech Republic',
	DE: 'Germany',
	DK: 'Denmark',
	EE: 'Estonia',
	ES: 'Spain',
	FI: 'Finland',
	FO: 'Faroe Islands',
	FR: 'France',
	GB: 'United Kingdom',
	GG: 'Guernsey',
	GI: 'Gibraltar',
	GR: 'Greece',
	HR: 'Croatia',
	HU: 'Hungary',
	IE: 'Ireland',
	IM: 'Isle of Man',
	IS: 'Iceland',
	IT: 'Italy',
	JE: 'Jersey',
	LI: 'Liechtenstein',
	LT: 'Lithuania',
	LU: 'Luxembourg',
	LV: 'Latvia',
	MC: 'Monaco',
	MD: 'Moldova, Republic of',
	MK: 'Macedonia, The Former Yugoslav Republic of',
	MT: 'Malta',
	NL: 'Netherlands',
	NO: 'Norway',
	PL: 'Poland',
	PT: 'Portugal',
	RO: 'Romania',
	RU: 'Russian Federation',
	SE: 'Sweden',
	SI: 'Slovenia',
	SJ: 'Svalbard and Jan Mayen',
	SK: 'Slovakia',
	SM: 'San Marino',
	UA: 'Ukraine',
	VA: 'Holy See (Vatican City State)',
};

export const northAmericaCountries = [
	'Antigua and Barbuda',
	'Bahamas',
	'Barbados',
	'Belize',
	'Canada',
	'Costa Rica',
	'Cuba',
	'Dominica',
	'Dominican Republic',
	'El Salvador',
	'Grenada',
	'Guatemala',
	'Haiti',
	'Honduras',
	'Jamaica',
	'Mexico',
	'Nicaragua',
	'Panama',
	'Saint Kitts and Nevis',
	'Saint Lucia',
	'Saint Vincent and the Grenadines',
	'Trinidad and Tobago',
	'United States',
];

export const getContinent = name => {
	if (northAmericaCountries.includes(name)) {
		return 'North America';
	}
	if (Object.values(europeanCountries).includes(name)) {
		return 'Europe';
	}
	if (name === 'Japan') {
		return 'Japan';
	}
	return 'Other';
};

export const getCountryColor = name => {
	if (northAmericaCountries.includes(name)) {
		return '#ffebee';
	}
	if (Object.values(europeanCountries).includes(name)) {
		return '#ffcc80';
	}
	if (name === 'Japan') {
		return '#ec407a';
	}
	return '#e0f2f1';
};
